var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoaderplacement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Loader_placement",
    "data-name": "Loader placement",
    transform: "translate(-73.816 38.184)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(73.816 -38.184)",
    fill: "#00263e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo_-_white",
    "data-name": "logo - white",
    transform: "translate(81.963 -30.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9631",
    "data-name": "Group 9631",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9629",
    "data-name": "Group 9629",
    transform: "translate(20.79 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26384",
    "data-name": "Path 26384",
    d: "M218.04,225.1v22.116c.08,0,.158.012.24.012a21.889,21.889,0,0,0,21.888-21.888c0-.082-.011-.16-.012-.241Z",
    transform: "translate(-218.04 -225.1)",
    fill: "#f7be00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26385",
    "data-name": "Path 26385",
    d: "M240.167,302.445c-.08,0-.158-.013-.24-.013A21.889,21.889,0,0,0,218.04,324.32c0,.082.011.16.012.241h22.115Z",
    transform: "translate(-218.04 -260.856)",
    fill: "#965ec7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9630",
    "data-name": "Group 9630",
    transform: "translate(0 20.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26386",
    "data-name": "Path 26386",
    d: "M179.344,285.866H201.46c0-.081.012-.158.012-.24a21.888,21.888,0,0,0-21.888-21.888c-.08,0-.16.011-.24.012Z",
    transform: "translate(-179.344 -263.738)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26387",
    "data-name": "Path 26387",
    d: "M256.747,263.738c0,.08-.012.158-.012.24a21.888,21.888,0,0,0,21.889,21.889c.079,0,.158-.011.238-.013V263.738Z",
    transform: "translate(-215.156 -263.738)",
    fill: "#ff8300"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderplacement);
export default __webpack_public_path__ + "static/media/Loader placement.c7259b647add1d36719527d76228759f.svg";
export { ForwardRef as ReactComponent };